import { ContractPaymentTypeRaw, ContractsPaymentType, ContractState } from '@/contracts/types/types';
import { ContractTypeId } from '@/api/contracts/types';

type ContractStateWithoutAktiv = Exclude<ContractState, ContractState.AKTIV>;

export const contractStatus: Record<ContractStateWithoutAktiv, string> = {
  [ContractState.STORNIERT]: 'Storniert',
  [ContractState.BEITRAGSFREI]: 'Beitragsfrei',
  [ContractState.SONSTIGE]: 'Sonstige',
  [ContractState.RUHEND]: 'Ruhend',
};

export const contractType: Record<ContractTypeId.ANTRAG, string> = {
  [ContractTypeId.ANTRAG]: 'Antrag gestellt',
};

export const intervalMap = new Map([
  [ContractPaymentTypeRaw.ANNUAL, ContractsPaymentType.ANNUAL],
  [ContractPaymentTypeRaw.SEMIANNUAL, ContractsPaymentType.SEMIANNUAL],
  [ContractPaymentTypeRaw.QUARTERLY, ContractsPaymentType.QUARTERLY],
  [ContractPaymentTypeRaw.MONTHLY, ContractsPaymentType.MONTHLY],
  [ContractPaymentTypeRaw.SINGLE_PAYMENT, ContractsPaymentType.SINGLE_PAYMENT],
  [ContractPaymentTypeRaw.OTHER, ContractsPaymentType.OTHER],
  [ContractPaymentTypeRaw.BEITRAGSFREI, ContractsPaymentType.BEITRAGSFREI],
]);
